import { useEffect, useState } from 'react';
import { TextField } from '@/features/form';
import { Toman } from '@/components/svg-symbols/icons';
import { toEnglish, toNumberCommas, toNumberWithoutCommas } from '@/utils/string-helpers';
interface Props {
  initialValue: number;
  sliderValue: number;
  type: 'min' | 'max';
  step: number;
  onSliderChange: (value: number, type: 'min' | 'max') => void;
}
const Input = ({
  sliderValue,
  initialValue,
  type,
  step,
  onSliderChange
}: Props) => {
  const [value, setValue] = useState(sliderValue);
  const otherInputProps = type === 'min' ? {
    min: initialValue
  } : {
    max: initialValue
  };
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue: string = toNumberWithoutCommas(e.target.value);
    const newValue: number = parseInt(toEnglish(inputValue), 10);
    !isNaN(newValue) && setValue(newValue);
  };

  // function will call when: enter key clicked | input blur
  const registerChangeHandler = () => {
    const roundMethod = type === 'max' ? Math.ceil : Math.floor;
    let roundedValue = roundMethod(value / step) * step;
    roundedValue = type === 'max' && roundedValue > initialValue ? initialValue : roundedValue;
    setValue(roundedValue);
    onSliderChange(roundedValue, type);
  };
  useEffect(() => {
    setValue(sliderValue);
  }, [sliderValue]);
  const title = type === 'max' ? 'حداکثر' : 'حداقل';
  const placeholder = type === 'max' ? 'مثلا ۶۰۰.۰۰۰' : 'مثلا ۱۰۰.۰۰۰';
  return <TextField id={type} inputSize='medium' leftIcon={<Toman className='h-6 w-6 fill-text-mediumGray' />} value={toNumberCommas(value)} onChange={onChange} onBlur={registerChangeHandler} onKeyDown={e => e.key === 'Enter' && registerChangeHandler()} title={title} placeholder={placeholder} {...otherInputProps} data-sentry-element="TextField" data-sentry-component="Input" data-sentry-source-file="input.tsx" />;
};
export default Input;